<template>
	<div>
		<default-widget-field v-bind="hubSpotFieldProps" v-on="defaultFieldListeners" />
		<template v-if="!isConfirming">
			<div v-if="!hubSpotURL" class="h-[300px] flex-centerize">
				<h1 class="no-url-text">Please enter a valid HubSpot scheduler URL</h1>
			</div>
			<div v-else class="meetings-iframe-container" :data-src="hubSpotURL"></div>
		</template>
		<div v-else>
			<div>You are scheduled</div>
			<Lottie class="animation-container" :width="100" :options="completedAnimation" />
		</div>
	</div>
</template>

<script>
import DefaultWidgetField from './DefaultWidgetField';
import WidgetFieldMixin from './WidgetFieldMixin';
import { CONFIRMATION_REDIRECT_OPTIONS } from '../confirmation-mini-app.const';
import Lottie from '@/assets/lottie/lottie.vue';
import CalendlyConfirm from '@/components/BlockEditorWidget/WidgetFields/assets/calendly-confirm.json';
import WidgetFormService from '@/components/WidgetForm/WidgetFormService';

function buildURL(string) {
	try {
		const baseUrl = new URL(string);
		baseUrl.searchParams.append('embed', 'true');
		return baseUrl;
	} catch (e) {
		return string;
	}
}

export default {
	name: 'HubSpotSchedulerInputField',
	components: {
		DefaultWidgetField,
		Lottie,
	},
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	mixins: [WidgetFieldMixin],
	computed: {
		completedAnimation() {
			return { animationData: CalendlyConfirm, loop: false };
		},
		metadataOptions() {
			return this.field.metadata.options;
		},
		currentPreviousSteps() {
			return this.previousSteps || this.flatPreviousSteps;
		},
		hubSpotLink() {
			return WidgetFormService.processPreviousSteps(this.metadataOptions.hubspot_link.value, this.currentPreviousSteps);
		},
		hubSpotFieldProps() {
			return { ...this.defaultFieldProps, titleEnabled: false };
		},
		confirmationHandlingOption() {
			return this.metadataOptions.confirmation_handling_option.value;
		},
		hubSpotURL() {
			return buildURL(this.hubSpotLink);
		},
	},
	methods: {
		isHubSpotBook(e) {
			return e.origin === this.hubSpotURL.origin && e.data.meetingBookSucceeded;
		},

		onEventSchedule(data) {
			const meetingDate = new Date(data.meetingsPayload.bookingResponse.event.dateTime);
			this.value = {
				contact: data.meetingsPayload.bookingResponse.postResponse.contact,
				date: meetingDate.toISOString(),
				duration: `${data.meetingsPayload.bookingResponse.event.duration / 60000} Minutes`,
				formFields: data.meetingsPayload.bookingResponse.event.formFields,
			};
			switch (this.confirmationHandlingOption) {
				case CONFIRMATION_REDIRECT_OPTIONS.withoutAnimation:
					this.$emit('on-mini-app-finished');
					break;
				case CONFIRMATION_REDIRECT_OPTIONS.defaultPage:
					this.$emit('disable-cancel-button');
					break;
				default:
					this.isConfirming = true;
					setTimeout(() => {
						this.$emit('on-mini-app-finished');
					}, 2000);
			}
		},
	},
	async mounted() {
		const newScript = document.createElement('script');
		newScript.id = 'widgetScript';
		newScript.type = 'text/javascript';
		newScript.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
		newScript.async = true;
		document.head.appendChild(newScript);
		window.addEventListener('message', (e) => {
			if (this.isHubSpotBook(e)) {
				this.onEventSchedule(e.data);
			}
		});
	},
	data: () => ({
		isConfirming: false,
	}),
};
</script>
<style scoped lang="scss">
.no-url-text {
	color: var(--secondary-font-color);
}
</style>
